/**
 * JourneyStageFilter Component
 *
 * Multi-select filter for customer journey stages.
 * Values are client-configured and loaded from the API.
 * Uses OR logic only - records matching ANY selected journey stage are included.
 * (AND logic not supported as records have single journey stage values)
 */

import { Route } from 'lucide-react';
import { FilterDropdown } from './FilterDropdown';
import type { BusinessContextFilterProps } from '../types/filter.types';

export function JourneyStageFilter({
  value,
  onChange,
  options,
  disabled = false,
  className,
}: BusinessContextFilterProps) {
  // Handle values change - always use OR logic for single-value fields
  const handleValuesChange = (values: string[] | undefined) => {
    if (!values || values.length === 0) {
      onChange(undefined);
    } else {
      onChange({
        values,
        logic: 'or',
      });
    }
  };

  return (
    <FilterDropdown
      value={value?.values}
      onChange={handleValuesChange}
      options={options}
      icon={<Route className="h-4 w-4" />}
      emptyLabel="All Journeys"
      pluralNoun="journeys"
      helperText="Select journey stages (matches any)"
      disabled={disabled}
      className={className}
    />
  );
}
